import { BrowserRouter, useNavigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ConfigProvider } from 'antd';
import { useEffect } from 'react';
import store ,{persistor} from './redux/store';

import FrontRoutes from './routes';
import BadgeClearer from './components/BadgeClearer';
import SessionValidator from './components/SessionValidator';
import { setNavigateFunction } from './utils/routerHelper';
import sessionValidationService from './services/sessionValidationService';
import './assets/css/style.css';
import './assets/css/responsive.css';


// Inner component to access useNavigate
function AppContent() {
  const navigate = useNavigate();

  useEffect(() => {
    // Set up global navigation for Firebase service
    setNavigateFunction(navigate);
    
    // Initialize Firebase service for push notifications
    const initializeFirebase = async () => {
      try {
        const firebaseService = (await import('./services/firebaseService')).default;
        await firebaseService.initialize();
        console.log('✅ Firebase initialized in App.js');
      } catch (error) {
        console.error('❌ Failed to initialize Firebase in App.js:', error);
      }
    };

    // Initialize session validation service
    const initializeSessionValidation = async () => {
      try {
        // Start periodic session validation
        sessionValidationService.startPeriodicValidation();
        console.log('✅ Session validation service initialized');
        
        // Perform initial session validation if user is logged in
        const state = store.getState();
        if (state?.auth?.user?.access_token) {
          await sessionValidationService.validateSession();
        }
      } catch (error) {
        console.error('❌ Failed to initialize session validation:', error);
      }
    };

    initializeFirebase();
    initializeSessionValidation();
  }, [navigate]);

  return (
    <>
      <SessionValidator showValidationStatus={false}>
        <BadgeClearer />
        <FrontRoutes />
      </SessionValidator>
    </>
  );
}

function App() {
  return (
    <>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor} >
          <ConfigProvider>
            <BrowserRouter>
              <AppContent />
            </BrowserRouter>
          </ConfigProvider>
        </PersistGate>
      </Provider>
    </>
  );
}

export default App;
